module.exports = __webpack_public_path__ + "img/ico-soporte-tecnico.9131ea5d.png";